import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import { BookingCostEstimationObject } from 'models/booking';
import { CostProvider, GuidedSearchTopic } from './types';

const CostSearchTopicsSvgMap = {
  'Office Visit': 'OfficeVisit',
  'Radiology Imaging': 'RadiologyImaging',
  'Pregnancy Imaging and Delivery': 'Pregnancy',
  'Cardiac Tests and Procedures': 'CardiacTests',
  'Endoscopy and Colonoscopy': 'Endoscopy',
  'Nerve and Muscle Tests': 'NerveAndMuscle',
  'Respiratory Tests and Therapy': 'Respiratory',
  'Sleep Wake': 'SleepWake',
  Surgery: 'Surgery'
};

export const sortGuidedSearchTopics = (guidedSearchTopics: GuidedSearchTopic[]) => {
  return guidedSearchTopics
    .map(topic => ({
      ...topic,
      svg: CostSearchTopicsSvgMap[topic.name as keyof typeof CostSearchTopicsSvgMap]
    }))
    .sort((a, b) => a.sort_order - b.sort_order);
};

export const uniqueProviders = (allProvidersArray: CostProvider[]) =>
  uniqBy(allProvidersArray, 'id');

export const handleCostTypes = (data: BookingCostEstimationObject) => ({
  localAverage: get(data, 'localAverage', {}),
  nationalAverage: get(data, 'nationalAverage', {})
});
